"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.callAPIError = exports.callAPISuccess = exports.CALL_API_FAIL = exports.CALL_API_SUCCESS = exports.CALL_API = void 0;
var ROOT = "@@api";
var CALL_API = "".concat(ROOT, "/CALL_API");
exports.CALL_API = CALL_API;
var CALL_API_SUCCESS = "".concat(ROOT, "/CALL_API_SUCCESS");
exports.CALL_API_SUCCESS = CALL_API_SUCCESS;
var CALL_API_FAIL = "".concat(ROOT, "/CALL_API_FAIL");
exports.CALL_API_FAIL = CALL_API_FAIL;

var callAPISuccess = function callAPISuccess(call) {
  return {
    type: CALL_API_SUCCESS,
    call: call
  };
};

exports.callAPISuccess = callAPISuccess;

var callAPIError = function callAPIError(call) {
  return {
    type: CALL_API_FAIL,
    call: call
  };
};

exports.callAPIError = callAPIError;